import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import dateFnsFormat from 'date-fns/format';
import enUs from 'date-fns/locale/en-US';
import DatePicker, { registerLocale } from 'react-datepicker';
import { Input } from 'reactstrap';
import common from 'constants/common';
import useOutsideClick from 'utils/useOutsideClick';

import 'react-datepicker/dist/react-datepicker.css';

registerLocale('en-Us', enUs);
const TimePicker = ({ value, defaultValue, valueChanged, format }) => {
  const ref = useRef();
  const [showTimeSelector, setShowTimeSelector] = useState(false);

  const onTimeChange = (date) => {
    const timeFormat = format || common.dateFormats.hoursMinutesPM;
    setShowTimeSelector(false);
    const time = dateFnsFormat(new Date(date), timeFormat);
    valueChanged(time);
  };

  useOutsideClick(ref, () => {
    setShowTimeSelector(false);
  });

  const startDate = useState(new Date());

  return (
    <div ref={ref}>
      <div
        onClick={() => {
          setShowTimeSelector(true);
        }}
      >
        <Input
          className="main-field-input"
          value={value}
          defaultValue={defaultValue}
          onChange={(e) => {
            valueChanged(e.target.value);
          }}
        />
      </div>
      {showTimeSelector && (
        <div className="time-picker">
          <DatePicker
            startDate={startDate}
            locale="en-Us"
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={1}
            inline
            dateFormat="h:mm aaaa"
            onChange={onTimeChange}
          />
        </div>
      )}
    </div>
  );
};
TimePicker.propTypes = {
  defaultValue: PropTypes.string,
  value: PropTypes.string,
  format: PropTypes.string,
  valueChanged: PropTypes.func,
};
export default TimePicker;
